/* eslint-disable camelcase */
/* eslint-disable sort-keys */

const PURCHASE_EVENTS = {
  'RENOVATION': 'Renovação Clubes',
  'REACTIVATION': 'Reativação Clubes',
  'SECOND_SUBSCRIPTION': 'Segunda Assinatura Clubes',
  'UPGRADE': 'Upgrade Clubes',
  'CANCELLATION_REQUEST': 'Solicitação de Cancelamento Clubes',
  'CANCELLATION_UNDO': 'Desfazer Cancelamento Clubes',
}

const PRODUCTS_DICT = {
  '1': 'monthlyCuradoria',
  '2': 'semesterlyCuradoria',
  '3': 'yearlyCuradoria',
  '4': 'monthlyIneditos',
  '5': 'semesterlyIneditos',
  '6': 'yearlyIneditos',
  '22': 'clubeBooksterCompleto',
}

const PLAN_DICT = {
  '1': 'Mensal',
  '2': 'Trimestral',
  '3': 'Anual',
  '4': 'Mensal',
  '5': 'Trimestral',
  '6': 'Anual',
  '22': 'Anual',
}

const CLUB_DICT = {
  '1': 'Curadoria',
  '3': 'Curadoria',
  '4': 'Ineditos',
  '6': 'Ineditos',
  '22': 'Bookster',
}

const PAYMENT_METHODS_DICT = {
  'CARTAO_CREDITO': 'card',
  'BOLETO': 'bank_slip',
  'PIX': 'pix',
}

export const triggerEvent = ( eventParams ) => {
  if ( !window.dataLayer ) {
    window.dataLayer = []
  }
  window.dataLayer.push( eventParams )
}

export const getProductNameFromPlanId = ( planId ) => {
  if ( planId === null || typeof planId === 'undefined' ) {
    return 'unregisteredProduct'
  }
  const productName = PRODUCTS_DICT[ planId.toString() ]
  return productName ? productName : 'unregisteredProduct'
}

export const getPaymentMethod = ( rawPaymentMethod ) => {
  const paymentMethod = PAYMENT_METHODS_DICT[ rawPaymentMethod ]
  return paymentMethod ? paymentMethod : 'unregisteredPaymentMethod'
}

export const getPlan = ( planId ) => {
  if ( planId === null || typeof planId === 'undefined' ) {
    return 'unregisteredPlan'
  }
  const plan = PLAN_DICT[ planId.toString() ]
  return plan ? plan : 'unregisteredPlan'
}

export const getClub = ( planId ) => {
  if ( planId === null || typeof planId === 'undefined' ) {
    return 'unregisteredPlan'
  }
  const club = CLUB_DICT[ planId.toString() ]
  return club ? club : 'unregisteredPlan'
}

export const reactivationEvent = ( {
  paymentMethod,
  productPrice,
  freightPrice,
  totalDiscount,
  paymentHash,
  promotionCoupon,
  planId,
} ) => {
  const fixedProductPrice = productPrice.toFixed( 2 )
  triggerEvent( {
    'event': 'product_purchase',
    'eventCategory': PURCHASE_EVENTS.REACTIVATION,
    'paymentMethod': getPaymentMethod( paymentMethod ),
    'ecommerce': {
      'value': fixedProductPrice,
      'shipping': freightPrice,
      'transactionId': paymentHash,
      'discountCode': promotionCoupon,
      'items': [
        {
          'itemName': getProductNameFromPlanId( planId ),
          'discount': totalDiscount,
          'category': PURCHASE_EVENTS.REACTIVATION,
          'category2': getClub( planId ),
          'variant': getPlan( planId ),
          'quantity': 1,
          'price': fixedProductPrice,
        }
      ]
    }
  } )
}

export const userDataEvent = ( {
  email,
  phone,
  name,
  userId,
  productPrice,
  freightPrice,
  totalDiscount,
  paymentHash,
  promotionCoupon,
  planId,
} ) => {
  const fixedProductPrice = Number( productPrice ).toFixed( 2 )
  const dadosUsuario = phone ? { phone } : {}
  triggerEvent( {
    'event': 'user_data',
    email,
    ...dadosUsuario,
    name,
    'user_id': userId,
    'ecommerce': {
      'value': fixedProductPrice,
      'transactionId': paymentHash,
      'shipping': freightPrice,
      'discountCode': promotionCoupon,
      'items': [
        {
          'itemName': getProductNameFromPlanId( planId ),
          'discount': totalDiscount,
          'category': PURCHASE_EVENTS.RENOVATION,
          'category2': getClub( planId ),
          'variant': getPlan( planId ),
          'quantity': 1,
          'price': fixedProductPrice,
        }
      ]
    }
  } )
}

export const renovationEvent = ( {
  paymentMethod,
  productPrice,
  freightPrice,
  totalDiscount,
  paymentHash,
  promotionCoupon,
  planId,
} ) => {
  const fixedProductPrice = Number( productPrice ).toFixed( 2 )
  triggerEvent( {
    'event': 'product_purchase',
    'eventCategory': PURCHASE_EVENTS.RENOVATION,
    'paymentMethod': getPaymentMethod( paymentMethod ),
    'ecommerce': {
      'value': fixedProductPrice,
      'transactionId': paymentHash,
      'shipping': freightPrice,
      'discountCode': promotionCoupon,
      'items': [
        {
          'itemName': getProductNameFromPlanId( planId ),
          'discount': totalDiscount,
          'category': PURCHASE_EVENTS.RENOVATION,
          'category2': getClub( planId ),
          'variant': getPlan( planId ),
          'quantity': 1,
          'price': fixedProductPrice,
        }
      ]
    }
  } )
}

export const secondSubscriptionEvent = ( {
  paymentMethod,
  productPrice,
  freightPrice,
  totalDiscount,
  paymentHash,
  promotionCoupon,
  planId,
} ) => {
  const fixedProductPrice = Number( productPrice ).toFixed( 2 )
  triggerEvent( {
    'event': 'product_purchase',
    'eventCategory': PURCHASE_EVENTS.SECOND_SUBSCRIPTION,
    'paymentMethod': getPaymentMethod( paymentMethod ),
    'ecommerce': {
      'value': fixedProductPrice,
      'transactionId': paymentHash,
      'shipping': freightPrice,
      'discountCode': promotionCoupon,
      'items': [
        {
          'itemName': getProductNameFromPlanId( planId ),
          'discount': totalDiscount,
          'category': PURCHASE_EVENTS.SECOND_SUBSCRIPTION,
          'category2': getClub( planId ),
          'variant': getPlan( planId ),
          'quantity': 1,
          'price': fixedProductPrice,
        }
      ]
    }
  } )
}

export const upgradeEvent = ( {
  paymentMethod,
  productPrice,
  freightPrice,
  totalDiscount,
  paymentHash,
  promotionCoupon,
  planId,
} ) => {
  const fixedProductPrice = Number( productPrice ).toFixed( 2 )
  triggerEvent( {
    'event': 'product_purchase',
    'eventCategory': PURCHASE_EVENTS.UPGRADE,
    'paymentMethod': getPaymentMethod( paymentMethod ),
    'ecommerce': {
      'value': fixedProductPrice,
      'transactionId': paymentHash,
      'shipping': freightPrice,
      'discountCode': promotionCoupon,
      'items': [
        {
          'itemName': getProductNameFromPlanId( planId ),
          'discount': totalDiscount,
          'category': PURCHASE_EVENTS.UPGRADE,
          'category2': getClub( planId ),
          'variant': getPlan( planId ),
          'quantity': 1,
          'price': fixedProductPrice,
        }
      ]
    }
  } )
}

export const cancelRequestEvent = ( { planId, motivo, submotivo, origem } ) => {
  triggerEvent( {
    'event': 'subscription_cancel_request',
    'eventCategory': PURCHASE_EVENTS.CANCELLATION_REQUEST,
    'itemName': getProductNameFromPlanId( planId ),
    'category2': getClub( planId ),
    'variant': getPlan( planId ),
    'cancelReason': motivo || null,
    'cancelSubReason': submotivo || null,
    'cancelOrigin': origem || null,
  } )
}

export const cancelUndoEvent = ( { planId } ) => {
  triggerEvent( {
    'event': 'subscription_cancel_undo',
    'eventCategory': PURCHASE_EVENTS.CANCELLATION_UNDO,
    'itemName': getProductNameFromPlanId( planId ),
    'category2': getClub( planId ),
    'variant': getPlan( planId ),
  } )
}
